import { useTranslation } from 'react-i18next';
import { cn, FileUtils } from '@shared/utils';
import { Button, Icon, Text } from '../';
import DownloadIcon from '@assets/icons/download.svg';
import FileIcon from '@assets/icons/file2.svg';

interface FileRowProps {
  className?: string;
  file: {
    id?: string;
    fileName: string;
    mimeType: string;
    fileSize: number;
  };
  onDownload?: () => void;
}

export const FileRow = (props: FileRowProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex w-full items-center justify-between gap-4', props.className)}>
      <div className='flex items-center gap-4'>
        <Icon
          className='flex size-10 shrink-0 items-center justify-center rounded-md bg-ghost-white dark:bg-light/5'
          icon={<FileIcon className='size-5' />}
        />
        <div>
          <Text weight='semibold'>{props.file.fileName}</Text>
          <Text size='sm' color='gray'>
            {FileUtils.formatMimeType(props.file.mimeType)} · {FileUtils.formatFileSize(props.file.fileSize)}
          </Text>
        </div>
      </div>
      <Button color='icon' aria-label={t('buttons.downloadFile', { fileName: props.file.fileName })} onClick={props.onDownload}>
        <Icon icon={<DownloadIcon />} />
      </Button>
    </div>
  );
};
